exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title_div_line_3[data-v-0324e039]{font-size:16px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3}.title_div_line_5[data-v-0324e039]{-webkit-line-clamp:5}.title_div_line_1[data-v-0324e039],.title_div_line_5[data-v-0324e039]{font-size:17px;font-weight:700;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical}.title_div_line_1[data-v-0324e039]{margin-left:5px;-webkit-line-clamp:1}", ""]);

// exports
